'use client'

import Button from '@lyra/core/components/Button'
import Section, { SectionProps } from '@lyra/core/components/Section'
import { isMainnet } from '@lyra/web/constants/env'
import { MINT_TESTNET_USDC_AMOUNT, TokenId } from '@lyra/web/constants/tokens'
import DepositButton from '@lyra/web/containers/common/DepositButton'
import useTransaction from '@lyra/web/hooks/useTransaction'
import { formatTokenBalance } from '@lyra/web/utils/tokens'
import React from 'react'

type Props = SectionProps

export default function HomeFirstDepositPromptSection({ ...sectionProps }: Props) {
  const { mintTestnetUsdc } = useTransaction()

  const headerSubtitle = isMainnet
    ? 'Deposit USDC, ETH, BTC and other tokens to start trading options and perps.'
    : `Mint ${formatTokenBalance(MINT_TESTNET_USDC_AMOUNT, TokenId.USDC)} for testing.`

  return (
    <Section {...sectionProps}>
      <Section.Header title="Get Started" subtitle={headerSubtitle} />
      <Section.XStack>
        {isMainnet ? (
          <DepositButton size="lg" minWidth={140} />
        ) : (
          <Button
            size="lg"
            minWidth={140}
            color="cta"
            isSolid
            label={`Mint USDC`}
            onPress={mintTestnetUsdc}
          />
        )}
      </Section.XStack>
    </Section>
  )
}
